export const noticeError = (message: string) => {
  if (!window?.newrelic?.noticeError) {
    return;
  }
  window.newrelic.noticeError(message);
};
